export enum WithdrawalPlanType {
  Group = "Group",
  OneOnOne = "OneOnOne",
}

export enum WithdrawalRequestSource {
  Platform = "Platform",
  Internal = "Internal",
}

export enum WithdrawalNotificationRecipient {
  Closer = "Closer",
  FallbackTeamLeader = "FallbackTeamLeader",
  StudentsTeam = "StudentsTeam",
}

export enum WithdrawalRequestStatus {
  Pending = "Pending",
  ToRefund = "ToRefund",
  WithdrawalAvoided = "WithdrawalAvoided",
  Refunded = "Refunded",
  PartiallyRefunded = "PartiallyRefunded",
  Cancelled = "Cancelled",
}

export enum WithdrawalOutcome {
  Confirmed = "Confirmed",
  Avoided = "Avoided",
}

export type WithdrawalRequestPlanSnapshotDTO = {
  planType: WithdrawalPlanType;
  planId: string;
  purchasedAtUtc: string;
  totalLessons?: number;
  lessonsPerWeek?: number;
  durationInWeeks?: number;
  startedAtWeekUtc?: string;
  endedAtWeekUtc?: string;
  warrantyEnabled?: boolean;
  promoIds?: string[];
  attendedLessonsCount?: number;
};

export type WithdrawalRequestDTO = {
  id: string;
  userId: string;
  userEmail: string;
  userGivenName: string;
  userFamilyName: string;
  purchaseKey?: string;
  orderId?: string;
  purchasedAtUtc: string;
  withdrawalDeadlineUtc: string;
  requestedAtUtc: string;
  source: WithdrawalRequestSource;
  status: WithdrawalRequestStatus;
  plans: WithdrawalRequestPlanSnapshotDTO[];
  attendedLessonsCount: number;
  dealId?: string;
  closerEmail?: string;
  closerName?: string;
  closerTeamName?: string;
  teamLeaderEmail?: string;
  notificationRecipient?: WithdrawalNotificationRecipient;
  notifiedAtUtc?: string;
  outcome?: WithdrawalOutcome;
  outcomeRawValue?: string;
  outcomeUpdatedAtUtc?: string;
  refundedAtUtc?: string;
  notes?: string;
  createdAt: string;
  updatedAt?: string;
};

export type WithdrawablePurchaseDTO = {
  purchaseKey?: string;
  orderId?: string;
  purchasedAtUtc: string;
  withdrawalDeadlineUtc: string;
  isWithinWithdrawalWindow: boolean;
  plans: WithdrawalRequestPlanSnapshotDTO[];
};
